module.exports = __webpack_public_path__ + "static/img/323_TO8_2501.bedc5aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/323_TO8_2501.jpg
// module id = +RMg
// module chunks = 0